
import React from 'react';
import { GameState } from '../types';

interface LobbyPageProps {
    gameState: GameState;
    currentPlayerId: string; // We need to know who the current player is
    onReady: () => void;
    onStartGame: () => void;
}

export const LobbyPage: React.FC<LobbyPageProps> = ({ gameState, currentPlayerId, onReady, onStartGame }) => {
    const { roomId, roomName, players } = gameState;
    const currentPlayer = players.find(p => p.id === currentPlayerId);
    const isHost = currentPlayer?.isHost || false;

    const handleStartGame = () => {
        // Rule: All players must be ready before starting
        const allReady = players.every(p => p.isReady || p.isHost);
        if (isHost && allReady) {
            onStartGame();
        } else {
            alert("所有玩家都必須準備好，房主才能開始遊戲！");
        }
    };

    return (
        <div className="lobby-container">
            <h2>房間: {roomName}</h2>
            <h3>房號: {roomId}</h3>
            <div className="player-list-container">
                <div className="player-list">
                    <h4>玩家 ({players.length})</h4>
                    <ul>
                        {players.map(player => (
                            <li key={player.id} className={player.isReady ? 'ready' : ''}>
                                {player.name}
                                {player.isHost && ' (房主)'}
                                {player.isReady && !player.isHost && ' - 已準備!'}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="lobby-actions with-padding">
                {isHost ? (
                    <button className="pixel-button" onClick={handleStartGame}>開始遊戲</button>
                ) : (
                    <button className="pixel-button" onClick={onReady} disabled={currentPlayer?.isReady}>
                        {currentPlayer?.isReady ? '已準備' : '我準備好了!'}
                    </button>
                )}
            </div>
        </div>
    );
};
